// extracted by css-extract-rspack-plugin
export default {"list":"list-2h8wt"};